import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { handleTree } from "@/utils/tree";
import vuescroll from 'vuescroll'
import MobileDetect from 'mobile-detect';

Vue.prototype.handleTree = handleTree
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(vuescroll)

store.dispatch('fetchListData');
const resetScreen = () => {
  // setTimeout(() => {
    // 创建一个新的检测实例，传入用户代理字符串
    const md = new MobileDetect(window.navigator.userAgent);
    // 判断设备是否为移动设备
    if (md.phone()) {
      store.commit('SET_ISMOBILE', true)
    }
    else {
      store.commit('SET_ISMOBILE', false)
      updateRootFontSize()
    }
    
  // }, 500)

}

const updateRootFontSize = () => {
  const baseSize = 14; // 基准字体大小
  const minFontSize = 2; // 最小字体大小
  const maxFontSize = 40; // 最大字体大小
  const designWidth = 1920; // 设计稿的宽度基准
  const clientWidth = document.documentElement.clientWidth; // 当前窗口的宽度
  const scale = clientWidth / designWidth; // 计算当前窗口宽度与设计稿宽度的比例
  let newSize = baseSize * scale;

  // 限制字体大小在最小和最大范围内
  if (newSize < minFontSize) {
    newSize = minFontSize;
  } else if (newSize > maxFontSize) {
    newSize = maxFontSize;
  }

  // 设置根元素的字体大小
  document.documentElement.style.fontSize = `${newSize}px`;

};

// 监听窗口大小变化，并动态调整字体大小
// window.addEventListener('resize', updateRootFontSize);
window.addEventListener('resize', resetScreen);
// 初始化时立即设置一次字体大小
// updateRootFontSize();
resetScreen()


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
